import { i18n } from "@/i18n"

const INTL_LOCALE: Record<string, string> = {
    ru: "ru-RU",
    en: "en-US",
    vi: "vi-VN"
}

// Читает i18n.global.locale, поэтому вызов внутри computed/шаблона
// пересчитается при смене языка.
export const intlLocale = (): string => {
    return INTL_LOCALE[String(i18n.global.locale)] ?? "ru-RU"
}

export const formatNumber = (value: number | null | undefined, options?: Intl.NumberFormatOptions): string => {
    return (value ?? 0).toLocaleString(intlLocale(), options)
}

// Денежные суммы. Валюту не подставляем — как и раньше, меняются только
// разделители разрядов в соответствии с языком пользователя.
export const formatMoney = (value: number | null | undefined): string => {
    return formatNumber(value)
}

const toDate = (value: Date | string | null | undefined): Date | null => {
    if (!value) {
        return null
    }

    const date = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(date.getTime())) {
        return null
    }

    return date
}

// dd.MM.yy по UTC
export const formatShortDate = (value: Date | string | null | undefined): string => {
    const date = toDate(value)
    if (!date) {
        return ''
    }

    const day = String(date.getUTCDate()).padStart(2, '0')
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const year = String(date.getUTCFullYear()).slice(-2)
    return `${day}.${month}.${year}`
}

// dd.MM.yyyy по местному времени — для мест, где нужен полный год.
export const formatDate = (value: Date | string | null | undefined): string => {
    const date = toDate(value)
    if (!date) {
        return ''
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    return `${day}.${month}.${date.getFullYear()}`
}

// dd.MM.yyyy HH:mm по местному времени.
export const formatDateTime = (value: Date | string | null | undefined): string => {
    const date = toDate(value)
    if (!date) {
        return ''
    }

    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${formatDate(date)} ${hours}:${minutes}`
}
